export default {
    message: {
        impersonation: "您代表 «{name}» 订购"
    }
}